"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _slicedToArray = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var DefaultVolumeIndicatorAdapter = /*#__PURE__*/function () {
  function DefaultVolumeIndicatorAdapter(logger, realtimeController, minVolumeDecibels, maxVolumeDecibels, selfAttendeeId) {
    _classCallCheck(this, DefaultVolumeIndicatorAdapter);
    this.logger = logger;
    this.realtimeController = realtimeController;
    this.minVolumeDecibels = minVolumeDecibels;
    this.maxVolumeDecibels = maxVolumeDecibels;
    this.selfAttendeeId = selfAttendeeId;
    this.streamIdToAttendeeId = {};
    this.streamIdToExternalUserId = {};
    this.warnedAboutMissingStreamIdMapping = {};
    this.attendeeIdToStreamId = {};
    this.sessionReconnected = false;
  }
  _createClass(DefaultVolumeIndicatorAdapter, [{
    key: "onReconnect",
    value: function onReconnect() {
      this.sessionReconnected = true;
    }
  }, {
    key: "sendRealtimeUpdatesForAudioStreamIdInfo",
    value: function sendRealtimeUpdatesForAudioStreamIdInfo(info) {
      var streamIndex = 0;
      var _iterator = _createForOfIteratorHelper(info.streams),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var stream = _step.value;
          var hasAttendeeId = !!stream.attendeeId;
          var hasExternalUserId = !!stream.externalUserId;
          var hasMuted = stream.hasOwnProperty('muted');
          var hasDropped = !!stream.dropped;
          if (hasAttendeeId) {
            if (!!this.attendeeIdToStreamId[stream.attendeeId] && this.attendeeIdToStreamId[stream.attendeeId] < stream.audioStreamId) {
              delete this.attendeeIdToStreamId[stream.attendeeId];
            }
            this.streamIdToAttendeeId[stream.audioStreamId] = stream.attendeeId;
            var externalUserId = hasExternalUserId ? stream.externalUserId : stream.attendeeId;
            this.streamIdToExternalUserId[stream.audioStreamId] = externalUserId;
            this.attendeeIdToStreamId[stream.attendeeId] = stream.audioStreamId;
            this.realtimeController.realtimeSetAttendeeIdPresence(stream.attendeeId, true, externalUserId, false, {
              attendeeIndex: streamIndex++,
              attendeesInFrame: info.streams.length
            });
          }
          if (hasMuted) {
            var attendeeId = this.streamIdToAttendeeId[stream.audioStreamId];
            var _externalUserId = this.streamIdToExternalUserId[stream.audioStreamId];
            this.realtimeController.realtimeUpdateVolumeIndicator(attendeeId, null, stream.muted, null, _externalUserId);
          }
          if (!hasAttendeeId && !hasMuted) {
            var _attendeeId = this.streamIdToAttendeeId[stream.audioStreamId];
            if (_attendeeId) {
              var _externalUserId2 = this.streamIdToExternalUserId[stream.audioStreamId];
              delete this.streamIdToAttendeeId[stream.audioStreamId];
              delete this.streamIdToExternalUserId[stream.audioStreamId];
              delete this.warnedAboutMissingStreamIdMapping[stream.audioStreamId];
              if (this.attendeeIdToStreamId[_attendeeId] === stream.audioStreamId) {
                delete this.attendeeIdToStreamId[_attendeeId];
              }
              var attendeeHasNewStreamId = false;
              for (var _i = 0, _Object$keys = Object.keys(this.streamIdToAttendeeId); _i < _Object$keys.length; _i++) {
                var otherStreamId = _Object$keys[_i];
                var otherStreamIdNumber = parseInt(otherStreamId);
                if (otherStreamIdNumber > stream.audioStreamId && this.streamIdToAttendeeId[otherStreamIdNumber] === _attendeeId) {
                  attendeeHasNewStreamId = true;
                  break;
                }
              }
              if (!attendeeHasNewStreamId) {
                this.realtimeController.realtimeSetAttendeeIdPresence(_attendeeId, false, _externalUserId2, hasDropped, {
                  attendeeIndex: streamIndex++,
                  attendeesInFrame: info.streams.length
                });
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (this.sessionReconnected) {
        this.cleanUpState(info);
        this.sessionReconnected = false;
      }
    }
  }, {
    key: "cleanUpState",
    value: function cleanUpState(info) {
      var localAttendeeIds = Object.values(this.streamIdToAttendeeId);
      var remoteAttendeeIds = info.streams.map(function (stream) {
        return stream.attendeeId;
      });
      var deletedAttendeeIds = localAttendeeIds.filter(function (id) {
        return !remoteAttendeeIds.includes(id);
      });
      var _iterator2 = _createForOfIteratorHelper(deletedAttendeeIds.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            index = _step2$value[0],
            deletedAttendeeId = _step2$value[1];
          var streamId = this.attendeeIdToStreamId[deletedAttendeeId];
          var externalUserId = this.streamIdToExternalUserId[streamId];
          delete this.streamIdToAttendeeId[streamId];
          delete this.streamIdToExternalUserId[streamId];
          delete this.warnedAboutMissingStreamIdMapping[streamId];
          delete this.attendeeIdToStreamId[deletedAttendeeId];
          // During reconnection, the audio info frame might not include self attendee.
          // However, if that happens, there would be another audio info frame with the self attendee after reconnection.
          // So we should not send leave event here for self attendee.
          if (deletedAttendeeId === this.selfAttendeeId) {
            this.logger.warn("the volume indicator adapter cleans up the current attendee (presence = false) after reconnection");
            continue;
          }
          // The reconnect event does not have information whether the attendee is dropped/left.
          // Defaulting to attendee leaving the meeting
          this.realtimeController.realtimeSetAttendeeIdPresence(deletedAttendeeId, false, externalUserId, false, {
            attendeeIndex: index,
            attendeesInFrame: deletedAttendeeId.length
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "sendRealtimeUpdatesForAudioMetadata",
    value: function sendRealtimeUpdatesForAudioMetadata(metadata) {
      var volumes = null;
      var signalStrengths = null;
      var _iterator3 = _createForOfIteratorHelper(metadata.attendeeStates),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var state = _step3.value;
          var attendeeId = this.attendeeIdForStreamId(state.audioStreamId);
          if (state.hasOwnProperty('volume')) {
            if (volumes === null) {
              volumes = {};
            }
            if (attendeeId !== null) {
              // @ts-ignore: TODO fix this protobufjs issue
              volumes[attendeeId] = this.normalizedVolume(state);
            }
          }
          if (state.hasOwnProperty('signalStrength')) {
            if (signalStrengths === null) {
              signalStrengths = {};
            }
            if (attendeeId !== null) {
              // @ts-ignore: TODO fix this protobufjs issue
              signalStrengths[attendeeId] = this.normalizedSignalStrength(state);
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.applyRealtimeUpdatesForAudioMetadata(volumes, signalStrengths);
    }
  }, {
    key: "normalizedVolume",
    value: function normalizedVolume(state) {
      var dBVolume = -state.volume;
      var normalized = 1.0 - (dBVolume - this.maxVolumeDecibels) / (this.minVolumeDecibels - this.maxVolumeDecibels);
      var clipped = Math.min(Math.max(normalized, 0.0), 1.0);
      return clipped;
    }
  }, {
    key: "normalizedSignalStrength",
    value: function normalizedSignalStrength(state) {
      var normalized = state.signalStrength / DefaultVolumeIndicatorAdapter.MAX_SIGNAL_STRENGTH_LEVELS;
      var clipped = Math.min(Math.max(normalized, 0.0), 1.0);
      return clipped;
    }
  }, {
    key: "applyRealtimeUpdatesForAudioMetadata",
    value: function applyRealtimeUpdatesForAudioMetadata(volumes, signalStrengths) {
      for (var streamId in this.streamIdToAttendeeId) {
        var attendeeId = this.streamIdToAttendeeId[streamId];
        var externalUserId = this.streamIdToExternalUserId[streamId];
        var volumeUpdate = null;
        var signalStrengthUpdate = null;
        if (volumes !== null) {
          if (volumes.hasOwnProperty(attendeeId)) {
            volumeUpdate = volumes[attendeeId];
          } else {
            volumeUpdate = DefaultVolumeIndicatorAdapter.IMPLICIT_VOLUME;
          }
        }
        if (signalStrengths !== null) {
          if (signalStrengths.hasOwnProperty(attendeeId)) {
            signalStrengthUpdate = signalStrengths[attendeeId];
          } else {
            signalStrengthUpdate = DefaultVolumeIndicatorAdapter.IMPLICIT_SIGNAL_STRENGTH;
          }
        }
        if (volumeUpdate !== null || signalStrengthUpdate !== null) {
          this.realtimeController.realtimeUpdateVolumeIndicator(attendeeId, volumeUpdate, null, signalStrengthUpdate, externalUserId);
        }
      }
    }
  }, {
    key: "attendeeIdForStreamId",
    value: function attendeeIdForStreamId(streamId) {
      if (streamId === 0) {
        return null;
      }
      var attendeeId = this.streamIdToAttendeeId[streamId];
      if (attendeeId) {
        return attendeeId;
      }
      if (!this.warnedAboutMissingStreamIdMapping[streamId]) {
        this.warnedAboutMissingStreamIdMapping[streamId] = true;
        this.logger.warn("volume indicator stream id ".concat(streamId, " seen before being defined"));
      }
      return null;
    }
  }]);
  return DefaultVolumeIndicatorAdapter;
}();
exports.default = DefaultVolumeIndicatorAdapter;
DefaultVolumeIndicatorAdapter.MAX_SIGNAL_STRENGTH_LEVELS = 2;
DefaultVolumeIndicatorAdapter.IMPLICIT_VOLUME = 0;
DefaultVolumeIndicatorAdapter.IMPLICIT_SIGNAL_STRENGTH = 1;